// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__1F1S9","dense":"_type_dense__2xVyj","slide-fwd-right":"_type_slide-fwd-right__F5iAY"};